
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/venda-direta/pessoa-com-deficiencia",
      function () {
        return require("private-next-pages/venda-direta/pessoa-com-deficiencia.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/venda-direta/pessoa-com-deficiencia"])
      });
    }
  